import { useContext } from "react"
import { AllContext } from "../Context/ContextProvider"

const useData = ()=>{
    return useContext(AllContext)
}
export default useData